import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=7d43d8c3&scoped=true&"
import script from "./Watchlist.vue?vue&type=script&lang=js&"
export * from "./Watchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d43d8c3",
  null
  
)

export default component.exports